export default {
  /**
   * 普通参数
   */
  username: 'erp.username', // 用户名

  /**
   * 后台分页器参数
   */
  adminPaginationOffset: 10, // 后端分页一页显示N条数据
  adminPaginationIndex: 1, // 后端分页初始值
  adminMaxPagination: 1, // 后端分页最大页码
  adminListLen: 0, // 后端分页总条数
  adminIndex2Fresh: true, // 后端分页当前页面改变需要刷新数据

  /**
   * 全局前端分页器参数
   */
  originList: [], // 原始数据
  tableList: [], // 表格数据
  paginationOffset: 10, // 一页显示N条数据
  paginationIndex: 1, // 分页初始值

  /**
   * Global Options
   */
  AppCode: 'erp.web.app.code', // AppCode
  MenuCode: 'erp.web.menu.code', // 当前选中菜单code
  keyToken: 'erp.token', // token key
  MCS: 'erp.MCodes', // MenuCode List
  MTS: 'erp.MTrees', // 菜单列表
  userEmpOrg: '', // 用户关联的员工机构
  tokenPre: 'Bearer ', // token 前缀
  tokenExpire: 'erp.expire', // token 有效期
  baseURL: '',
  empName: 'erp.emp_name',
  isMgr: 'isMgr',
  keepAlivePage: [], // 缓存页面
  routes: [], // 缓存的路径
  currentMenu: {}
}



// WEBPACK FOOTER //
// ./src/store/common/state.js